import { Injectable, OnDestroy } from '@angular/core';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';
import { IPostCreateSPM, ISPM_ResponseData } from '../spm/spm.interface';
import { Router } from '@angular/router';
import { BehaviorSubject, shareReplay, Subscription, tap } from 'rxjs';
import { IGetStock, IResponseSO } from '@models/product-order.model';
import { IFilterStatusSO, IPriceSummary, ISalesOrderDetail } from '@models/sales-order.model';
import { map } from 'rxjs/operators';
import { StatusFilterEnumSalesOrder } from './submenu.enum';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { FormBuilder } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderLegacyService implements OnDestroy {
  soDetailSubject: BehaviorSubject<ISalesOrderDetail>;

  private unsubscribe: Subscription[] = [];
  private salesOrderDetail$ = new BehaviorSubject({} as ISalesOrderDetail);

  private initDataSpmFormSubject = new BehaviorSubject(null as unknown as ISPM_ResponseData);

  constructor(public fb: FormBuilder, protected baseService: BaseService, public router: Router, public rolePrivilegeService: RolePrivilegeService) {
    this.soDetailSubject = new BehaviorSubject<ISalesOrderDetail>({} as ISalesOrderDetail);

    const _dataSubs = this.salesOrderDetail$.pipe(shareReplay()).subscribe((resp) => this.soDetailSubject.next(resp));
    this.unsubscribe.push(_dataSubs);
  }

  get SalesOrderDetail() {
    return this.soDetailSubject.value;
  }

  set SalesOrderDetail(data: ISalesOrderDetail) {
    this.soDetailSubject.next(data);
  }

  get InitDataSPMForm() {
    return this.initDataSpmFormSubject.value;
  }

  set InitDataSPMForm(data) {
    this.initDataSpmFormSubject.next(data);
  }

  getSOStock(payload: { soID: string; warehouseID: string }) {
    let { warehouseID } = payload;
    const {soID} = payload

    warehouseID = !warehouseID ? warehouseID : `warehouse_id=${warehouseID}`;
    const param = `${soID}?${warehouseID}`;

    return this.baseService.getData<IGetStock[]>(`${API.GET_STOCK}${param}`);
  }

  getSPMSOV2Stock(salesOrderId: string) {
    return this.baseService.getData<ISPM_ResponseData>(`${API.GET_STOCK_SO_v2_SPM}${salesOrderId}`).pipe(
      shareReplay(),
      map((resp) => resp),
      tap((res) => {
        if (res && res.success) this.InitDataSPMForm = res.data;
      })
    );
  }

  postSPMSOFormV2(payload: IPostCreateSPM, salesOrderId: string) {
    return this.baseService.postData<IResponseSO>(API.CREATE_SPM_V2_NEED_FULLFILL + salesOrderId, payload);
  }

  goToApprovalTAG(_info: { soID: string; soStatus?: string; soCode?: string }) {
    const { soID, soCode } = _info;
    let {soStatus} = _info
    soStatus = soStatus?.toLowerCase();
    return this.router.navigate(['/sales-order/approval-so-tag/'], {
      queryParams: {
        so_id: soID,
        so_code: soCode,
        so_status: soStatus,
      },
    });
  }

  goToDetail = (soID: string, status: string) => this.router.navigate([`/sales-order/${status}/${soID}`]);

  goToList = () => this.router.navigate(['/sales-order/list']);

  generateClassProcessLimit(value: string) {
    if (value === '-') return;
    if (value) {
      const val = Number(value.substring(0, 1));
      return val <= 3 ? 'text-danger' : '';
    }
  }

  getFilterStatusSO() {
    return this.baseService.getData<IFilterStatusSO[]>(API.SALES_ORDER.LIST_FILTER_STATUS_SALES_ORDER).pipe(
      map((resp) => {
        if (resp && resp.success) {
          const _status = [
            StatusFilterEnumSalesOrder.WAITING_CENTRAL_ADMIN,
            StatusFilterEnumSalesOrder.WAITING_FINANCE,
            StatusFilterEnumSalesOrder.OUTSTANDING,
            StatusFilterEnumSalesOrder.IN_PROGRESS,
            StatusFilterEnumSalesOrder.PARTIAL_COMPLETED,
            StatusFilterEnumSalesOrder.COMPLETED,
            StatusFilterEnumSalesOrder.REJECTED,
            StatusFilterEnumSalesOrder.EXPIRED,
          ];
          const _filters: any = [];
          _status.map((val) => {
            const data = resp.data.find((item) => item.status_enum === val);
            _filters.push(data);
          });
          resp.data = _filters;
        }
        return resp;
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  soDetailIsEmpty = () => !Object.keys(this.soDetailSubject.value).length;

  getSoDetailById(id: string) {
    return this.baseService.getData<ISalesOrderDetail>(API.GET_DETAIL_SALES_ORDER + id).pipe(
      map((resp) => {
        if (resp && resp.success) this.SalesOrderDetail = resp.data;
        return resp;
      })
    );
  }

  getSoPriceSummaryById(id: string) {
    return this.baseService.getData<IPriceSummary>(API.GET_PRICE_SUMMARY_SALES_ORDER + id);
  }

}

// Todo: remove unused
